module.exports = "/images/form-needs-signature.png?9ea8e7a13f11739273973ba857f3d7cb";